import React from 'react'
import { Link } from 'react-router-dom'
import { useSearchBox } from 'lib/modules/misc'
import { Spinner } from 'lib/ui'

interface Props {
  withSuggestions?: boolean
}

export const SearchBox = ({ withSuggestions }: Props) => {
  const {
    value,
    products,
    totalCount,
    showSuggestions,
    isAwaiting,
    goToSearchPage,
    handleFormSubmit,
    handleInputBlur,
    handleInputChange,
    handleInputFocus
  } = useSearchBox({ withSuggestions })

  return (
    <div>
      <form
        onSubmit={handleFormSubmit}
      >
        <input
          type='text'
          autoComplete='off'
          maxLength={128}
          placeholder='Search entire store'
          value={value}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          onChange={handleInputChange}
        />
        <button
          type='submit'
        >
          {isAwaiting ? (
            <Spinner size={16} />
          ) : (
            <svg viewBox='0 0 46 46'>
              <path d='M40.441 45.966L29.506 35.031a19.002 19.002 0 0 1-10.444 3.111C8.523 38.142 0 29.6 0 19.061 0 8.542 8.522 0 19.062 0c10.521 0 19.06 8.542 19.06 19.061 0 3.679-1.036 7.107-2.828 10.011l11.013 11.011c.583.567.094 1.981-1.076 3.148l-1.64 1.644c-1.17 1.167-2.584 1.656-3.15 1.091zm-8.653-26.905c0-7.033-5.695-12.727-12.727-12.727-7.033 0-12.745 5.694-12.745 12.727s5.712 12.745 12.745 12.745c7.032 0 12.727-5.711 12.727-12.745z' />
            </svg>
          )}
        </button>
      </form>
      {showSuggestions && (
        <div>
          <ul>
            {products?.map(product => {
              return (
                <li key={product.id}>
                  <Link to={product.getUrlPath()}>
                    <img src={product.image.thumbnail.url} alt='' width={50} height={50} />
                    <span>{product.name}</span>
                  </Link>
                </li>
              )
            })}
            <li><button type='button' onClick={() => goToSearchPage()}>See more results ({totalCount})</button></li>
          </ul>
        </div>
      )}
    </div>
  )
}
